export default __webpack_public_path__ + "static/media/voha-2.64841505.png";